import * as angular from 'angular';

export class CustomFieldsService {

    constructor() {
    }

    parseCustomFields(fields) {
        let tmpCustomFields = [];

        // Mapping analogous to CustomField.value_column property in backend.
        let value_column_map = {select: "choice", multi_select: "multi_choice"};
        let f_type;

        for (let key in fields) {
            if (fields[key].value && (!Array.isArray(fields[key].value) || fields[key].value.length > 0)) {
                if (fields[key].field_type in value_column_map) {
                    f_type = value_column_map[fields[key].field_type];
                } else {
                    f_type = fields[key].field_type;
                }
                let tmpCustomField = {
                    custom_field: fields[key].id
                };
                tmpCustomField[f_type + '_value'] = fields[key].value;
                tmpCustomFields.push(tmpCustomField);
            }
        }

        return tmpCustomFields;
    }
}

angular
    .module('app')
    .service('CustomFieldsService', CustomFieldsService);



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/custom-fields.service.ts